import Scrollspy from "react-scrollspy";
import { useRef } from "react";

interface StaticPageData {
  title?: string;
  children?: React.ReactNode;
}

interface Props {
  textContentData?: StaticPageData[];
  children?: React.ReactNode;
  className?: string;
}

import { Button } from "../../../shadcn/components/ui/button";
const ScrollerStaticPage = ({
  textContentData,
  children,
  className,
}: Props) => {
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  const scrollToSection = (index: number) => {
    const section = sectionRefs.current[index];
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="scroller-page">
      {textContentData && (
        <div
          className={`px-customPadding flex 2xl:px-0 2xl:w-[1340px] 2xl:mx-auto ${className}`}
        >
          {" "}
          <Scrollspy
            className="sticky top-0 h-screen w-[390px] items-center flex-shrink-0"
            items={textContentData?.map((_, index) => `section-${index}`)}
            currentClassName="active-scroll-spy"
          >
            {textContentData?.map((section, index) => (
              <Button
                key={index}
                variant={"custom"}
                size={"custom"}
                className={`block text-wrap text-start mb-4 p-2 text-brand-textGrey`}
                onClick={() => scrollToSection(index)}
              >
                {section?.title}
              </Button>
            ))}
          </Scrollspy>
          <div className="overflow-y-auto ml-[84px] scrollbar-hide h-full">
            {children}
            {textContentData?.map((section, index) => (
              <div
                key={index}
                id={`section-${index}`}
                ref={(el) => (sectionRefs.current[index] = el)}
                className="mb-[70px]"
              >
                <h2 className="mb-8 font-openSans font-normal text-web-h3 leading-[30px] text-brand-bgBlack">
                  {section.title}
                </h2>
                <div className="font-openSans font-normal text-web-body-lg leading-5 text-brand-textGrey">
                  {section?.children}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScrollerStaticPage;
